import logo from 'Assets/Images/Tria_Mark_White 1.png'
import Button from 'Components/Base/Button'
import Column from 'Components/Base/Column'
import Icon from 'Components/Base/Icon'
import Row from 'Components/Base/Row'
import Typography from 'Components/Base/Typography'
import dayjs from 'dayjs'
import { Formik, FormikProps, useFormik } from 'formik'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import useAnalytics from 'hooks/useAnalytics'
import useMessagingCenter from 'hooks/useMessagingCenter'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDropzone } from 'react-dropzone'
import { getAccessToken } from 'reducers/authSlice'
import { setLoading } from 'reducers/tempSlice'
import styled, { useTheme } from 'styled-components'
import { Message, ReplyMessageValues } from 'types/MessagingCenter'

interface Props {
  isMobile: boolean
  currentMessage: Message
  refreshMessagesUponSend: (number: number) => void
  handleArchiveClick: (PIMessageId: number) => void
  replyBool: boolean
  setReplyBool: (bool: boolean) => void
  setAttachmentDropOpen: (bool: boolean) => void
  postErrorBool: boolean
  setPostErrorBool: (bool: boolean) => void
}

type InputField = {
  type: string
  fieldName: string
  width: string
}
export default function NewMessage({
  currentMessage,
  handleArchiveClick,
  refreshMessagesUponSend,
  replyBool,
  setReplyBool,
  isMobile,
  setAttachmentDropOpen,
  setPostErrorBool,
  postErrorBool,
}: Props) {
  const [errorBool, setErrorBool] = useState<boolean>(false)
  const [comments, setComments] = useState<string>('')
  const token = useAppSelector(getAccessToken)
  const analytics = useAnalytics(token!)
  const { updateAttachment, getAttachment } = useMessagingCenter(token!)

  const onDrop = useCallback((files: File[]) => {
    const tempFiles = formikRef.current?.values.documents
    files.map((file) => {
      tempFiles?.push(file)
    })
    formikRef.current?.setFieldValue('documents', tempFiles)
    formik.setFieldValue('documents', tempFiles)
  }, [])

  const removeFile = (file: File) => {
    const files = formikRef.current?.values.documents.filter((x) => x.name !== file.name)
    formikRef.current?.setFieldValue('documents', files)
    formik.setFieldValue('documents', files)
  }

  const { getRootProps, getInputProps } = useDropzone({ onDrop })

  const theme = useTheme()
  const dispatch = useAppDispatch()
  const accessToken = useAppSelector(getAccessToken)
  const { postPatientReply, addPatientMessage } = useMessagingCenter(accessToken!)

  const formikRef = useRef<FormikProps<ReplyMessageValues>>(null)

  const inputFields: InputField[] = [{ type: 'string', fieldName: 'messageBody', width: '90%' }]

  useEffect(() => {
    scrollDown()
    formik.setFieldValue('messageBody', '')
    formik.setFieldValue('patientInitiatedMessagePId', currentMessage?.patientInitiatedMessagePId)
    formikRef.current?.setFieldValue('documents', [])
    formik.setFieldValue('documents', [])
  }, [replyBool])

  const onSubmit = (links) => {
    //
  }

  const initialValues = {
    patientInitiatedMessagePId: currentMessage?.patientInitiatedMessagePId ?? 0,
    messageBody: '',
    documents: [],
  }
  const formik = useFormik({
    initialValues,
    onSubmit,
  })

  const inputRef = useRef<HTMLTextAreaElement>(null)

  const handleReplySendClick = () => {
    if (inputRef.current?.value === '') {
      setErrorBool(true)
    } else {
      setErrorBool(false)
      dispatch(setLoading(true))
      setReplyBool(false)
      if (formik.values.patientInitiatedMessagePId) {
        postPatientReply(formik.values).then((res) => {
          if (res && res.data.isFailed) {
            setComments(res.data.reasons[0].message)
            setReplyBool(true)
            setPostErrorBool(true)
            dispatch(setLoading(false))
          } else {
            refreshMessagesUponSend(1)
          }
        })
      } else {
        addPatientMessage({
          triaInitiatedMessagePId: currentMessage.triaInitiatedMessagePId,
          documents: formik.values.documents,
          messageBody: formik.values.messageBody,
          patientInitiatedMessageTypePId: currentMessage.replyMessageTypePId,
          enrollmentStatus: '',
        }).then((res) => {
          if (res && res.data.isFailed) {
            setComments(res.data.reasons[0].message)
            setReplyBool(true)
            setPostErrorBool(true)
            dispatch(setLoading(false))
          } else {
            refreshMessagesUponSend(2)
          }
        })
      }
      formik.values.messageBody = ''
      setAttachmentDropOpen(false)
    }
  }
  useEffect(() => {
    if (inputRef.current?.value !== '') {
      setErrorBool(false)
    }
  }, [inputRef.current?.value])

  const conversation = useRef<null | HTMLDivElement>(null)

  const scrollDown = () => {
    conversation.current && (conversation.current.scrollTop = conversation.current.scrollHeight)
  }
  useEffect(() => {
    scrollDown()
  }, [currentMessage])

  const handleReplyOpen = () => {
    setReplyBool(true)
    analytics.postAnalyticsPageView(`/messaging/inbox/reply`)
  }

  const handleOpenDoc = (attachmentPath: string, patientInitiatedMessageId: number, triaInitiatedMessagePId: number) => {
    getAttachment(attachmentPath, `${patientInitiatedMessageId}`, `${triaInitiatedMessagePId}`).then((res: any) => {
      window.open(res.data.startsWith('http') ? res.data : `https://${res.data}`)
    })
  }

  return (
    <StyledCurrentMessageCardContainer>
      {currentMessage && currentMessage.triaAttachments ? (
        <>
          <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={(values) => console.log(values)}>
            {({ values }) => {
              return (
                <div>
                  <StyledConversationContainer ref={conversation}>
                    <div
                      style={{
                        width: '98%',
                        height: 'fit-content',
                        padding: 10,
                        margin: 'auto',
                        backgroundColor: '#fff',
                        position: 'sticky',
                        top: 0,
                        borderTop: '10px solid white',
                      }}
                    >
                      <Row>
                        <Typography color="#000" size={20} variant="h3">
                          {currentMessage.subject}
                        </Typography>
                        {!currentMessage.archived && (
                          <div style={{ marginLeft: 'auto', marginTop: 7 }}>
                            <Row>
                              <div onClick={() => handleArchiveClick(currentMessage.patientInitiatedMessagePId)} style={{ cursor: 'pointer' }}>
                                <Icon name="archive" color="#4F4F4F" styles={{ marginRight: 0, marginLeft: 17 }} size="xl" />
                                <Typography size={16} color="#4F4F4F" styles={{ fontWeight: 600 }}>
                                  Archive
                                </Typography>
                              </div>
                            </Row>
                          </div>
                        )}
                      </Row>
                    </div>
                    {currentMessage.body && (
                      <Column styles={{ width: '93%', padding: 10, margin: 'auto' }}>
                        <Row>
                          <div
                            style={{ height: 56, width: 61.14, backgroundColor: theme.colors.primary1, borderRadius: 100, justifyContent: 'center' }}
                          >
                            <img src={logo} width={39} height={32} style={{ marginLeft: '9px', marginTop: 12 }} alt="tria logo" />
                          </div>

                          <Column
                            styles={{
                              textAlign: 'left',
                              width: '100%',
                              marginLeft: 20,
                              marginBottom: 20,
                              marginTop: 7,
                            }}
                          >
                            <Typography variant="h3" size={16}>
                              Tria
                            </Typography>
                            <Typography size={16}>{`${dayjs(currentMessage.messageDate).format('h:mm A')}`}</Typography>
                          </Column>
                        </Row>
                        {currentMessage.body.split('|').map((text, index) => {
                          if (text.startsWith('-')) {
                            return (
                              <Row styles={{ marginLeft: 20 }} key={index}>
                                <li style={{ fontFamily: 'Raleway' }}>{text.slice(1, text.length)}</li>
                              </Row>
                            )
                          } else {
                            return (
                              <Row styles={{ marginBottom: index === currentMessage.body.split('|').length - 1 ? 0 : 10 }} key={index}>
                                <Typography>{text}</Typography>
                              </Row>
                            )
                          }
                        })}
                      </Column>
                    )}

                    {currentMessage &&
                      currentMessage.conversations.map((message) => (
                        <div style={{ width: '93%', padding: 10, margin: 'auto' }} className="careplan-detail-document-item">
                          <Row styles={{ marginBottom: 20 }}>
                            {message.fromTria ? (
                              <div
                                style={{
                                  height: 56,
                                  width: 61.14,
                                  backgroundColor: theme.colors.primary1,
                                  borderRadius: 100,
                                  justifyContent: 'center',
                                }}
                              >
                                <img src={logo} width={39} height={32} style={{ marginLeft: '9px', marginTop: 12 }} alt="tria logo" />
                              </div>
                            ) : (
                              <div
                                style={{
                                  height: 56,
                                  width: 61.14,
                                  backgroundColor: theme.colors.darkGray,
                                  borderRadius: 100,
                                  justifyContent: 'center',
                                }}
                              >
                                <Typography styles={{ marginLeft: '19px', marginTop: 7, fontWeight: 600 }} size={28} color="#fff">
                                  {message.username[0]}
                                </Typography>
                              </div>
                            )}
                            <Column
                              styles={{
                                textAlign: 'left',
                                width: '100%',
                                marginLeft: 20,
                                marginBottom: 10,
                                marginTop: 7,
                              }}
                            >
                              <Typography variant="h3" size={16}>
                                {message.username}
                              </Typography>
                              <Typography size={16}>{`${dayjs(message.messageDate).format('h:mm A')}`}</Typography>
                            </Column>
                          </Row>
                          <Row
                            styles={{
                              width: '99%',
                              margin: 'auto',
                              cursor: 'pointer',
                              marginBottom: 10,
                            }}
                          >
                            <Row>
                              <Column>
                                <Row
                                  styles={{
                                    textAlign: 'left',
                                    width: '100%',
                                    marginBottom: 15,
                                  }}
                                >
                                  <Typography size={18}>{`${message.body}`}</Typography>
                                </Row>
                                {message.patientAttachments &&
                                  message.patientAttachments.length > 0 &&
                                  message.patientAttachments
                                    .filter((a) => !a.fromTria)
                                    .map((a) => (
                                      <Row>
                                        <Typography>{a.displayName}</Typography>
                                      </Row>
                                    ))}
                              </Column>
                            </Row>
                          </Row>
                        </div>
                      ))}

                    <div>
                      {errorBool && (
                        <Typography color="red" styles={{ marginLeft: 40, marginTop: 10 }}>
                          *Message Required
                        </Typography>
                      )}
                      {postErrorBool && (
                        <Typography color="red" styles={{ marginLeft: 40, marginTop: 10 }}>
                          {comments ? comments : 'There was an error. Please try again'}
                        </Typography>
                      )}
                      {replyBool &&
                        inputFields.map((field, index) => {
                          return (
                            <Column key={index} styles={{ marginRight: 'auto' }}>
                              <Form onSubmit={() => handleReplySendClick()}>
                                <StyledFormInput
                                  //type={field.type}
                                  ref={inputRef}
                                  style={{ width: field.width, textAlign: 'left' }}
                                  onChange={(value) => formik.setFieldValue(field.fieldName, value.currentTarget.value)}
                                  value={formik.values[field.fieldName]}
                                  placeholder={'Write a message'}
                                />
                              </Form>
                            </Column>
                          )
                        })}
                    </div>
                    {!currentMessage.archived ? (
                      <>
                        <Row styles={{ marginLeft: 30 }}>
                          {values.documents.map((file, index) => (
                            <Row styles={{ marginTop: 10, alignItems: 'center', marginLeft: 10 }} key={index}>
                              <Typography styles={{ marginRight: 5 }}>{file.name}</Typography>
                              <div onClick={() => removeFile(file)} style={{ cursor: 'pointer' }}>
                                <Icon name="times" />
                              </div>
                            </Row>
                          ))}
                        </Row>
                        {replyBool ? (
                          <Row styles={{ width: '100%', justifyContent: 'space-between' }}>
                            <div {...getRootProps()}>
                              <Button
                                text="Attach"
                                backgroundColor={theme.colors.darkGray}
                                leftIcon="attachment"
                                styles={{ marginTop: 10, marginLeft: '45px', height: 40, marginBottom: 40, width: 131 }}
                                onClick={() => console.log('th')}
                              />
                              <input {...getInputProps()} />
                            </div>
                            <Button
                              text="Send"
                              backgroundColor={theme.colors.primary1}
                              styles={{ marginTop: 10, marginLeft: 'auto', height: 40, marginBottom: 40, width: 106, marginRight: 50 }}
                              onClick={() => handleReplySendClick()}
                            />
                          </Row>
                        ) : (
                          <>
                            {(!currentMessage.triaInitiatedMessagePId || currentMessage.allowReply) && (
                              <Button
                                text="Reply"
                                backgroundColor={theme.colors.primary1}
                                styles={{ marginTop: 10, marginLeft: '40px', marginBottom: 40, width: 106 }}
                                onClick={handleReplyOpen}
                              />
                            )}
                            {(currentMessage.portalUrl || currentMessage.url) && (
                              <Button
                                text="Explore"
                                backgroundColor={'#0092BC'}
                                styles={{ marginTop: 10, marginLeft: '40px', marginBottom: 40, width: 106 }}
                                onClick={() => (currentMessage.portalUrl ? window.open(currentMessage.portalUrl) : window.open(currentMessage.url!))}
                              />
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <Typography color={theme.colors.primary1} size={18} styles={{ margin: 20 }}>
                        This conversation has been closed. Please initiate a new conversation if you need further assistance.
                      </Typography>
                    )}
                  </StyledConversationContainer>
                </div>
              )
            }}
          </Formik>
          {((currentMessage.triaAttachments.length > 0 && currentMessage.triaAttachments.filter((a) => a.attachmentType === 1).length > 0) ||
            currentMessage.conversations.find((m) => m.fromTria && m.patientAttachments.filter((a) => a.attachmentType === 1).length > 0)) && (
            <StyledLinkContainer>
              <Typography size={20} styles={{ fontWeight: 600 }}>
                Links:
              </Typography>
              {currentMessage.triaAttachments
                .filter((a) => a.attachmentType === 1)
                .map((a) => {
                  return a.displayName ? (
                    <Row>
                      {a.liked ? (
                        <div
                          onClick={() => {
                            updateAttachment(a.id).finally(() => refreshMessagesUponSend(1))
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <Icon name="heart" styles={{ marginRight: 10, color: theme.colors.charts.dangerousLow }} />
                        </div>
                      ) : (
                        <div
                          onClick={() => {
                            updateAttachment(a.id).finally(() => refreshMessagesUponSend(1))
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <Icon name="heartOutline" styles={{ marginRight: 10 }} />
                        </div>
                      )}
                      <Row onClick={() => handleOpenDoc(a.guid, currentMessage.patientInitiatedMessagePId, currentMessage.triaInitiatedMessagePId)}>
                        <Typography styles={{ textDecoration: 'underline', cursor: 'pointer' }} size={16}>
                          {a.displayName}
                        </Typography>
                      </Row>
                    </Row>
                  ) : (
                    <></>
                  )
                })}
              {currentMessage.conversations.map((m) => {
                const result = m.patientAttachments
                  .filter((a) => a.attachmentType === 1 && a.fromTria)
                  .map((a) => {
                    return a.displayName ? (
                      <Row>
                        {a.liked ? (
                          <div
                            onClick={() => {
                              updateAttachment(a.id).finally(() => refreshMessagesUponSend(1))
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <Icon name="heart" styles={{ marginRight: 10, color: theme.colors.charts.dangerousLow }} />
                          </div>
                        ) : (
                          <div
                            onClick={() => {
                              updateAttachment(a.id).finally(() => refreshMessagesUponSend(1))
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <Icon name="heartOutline" styles={{ marginRight: 10 }} />
                          </div>
                        )}
                        <Row onClick={() => handleOpenDoc(a.guid, currentMessage.patientInitiatedMessagePId, currentMessage.triaInitiatedMessagePId)}>
                          {/* //<a href={a.url.startsWith('http') ? a.url : `https://${a.url}`} rel="noreferrer" target="_blank"> */}
                          <Typography styles={{ textDecoration: 'underline', cursor: 'pointer' }} size={16}>
                            {a.displayName}
                          </Typography>
                          {/* //</a> */}
                        </Row>
                      </Row>
                    ) : (
                      <></>
                    )
                  })
                return result
              })}
            </StyledLinkContainer>
          )}
          {(currentMessage.triaAttachments.filter((a) => a.attachmentType === 2).length > 0 ||
            currentMessage.conversations.find((m) => m.fromTria && m.patientAttachments.filter((a) => a.attachmentType === 2).length > 0)) && (
            <StyledLinkContainer>
              <Typography size={20} styles={{ fontWeight: 600 }}>
                Documents:
              </Typography>
              <ul style={{ marginLeft: -15 }}>
                {currentMessage.triaAttachments
                  .filter((a) => a.attachmentType === 2)
                  .map((a) => {
                    return a.displayName ? (
                      <li>
                        <Row onClick={() => handleOpenDoc(a.guid, currentMessage.patientInitiatedMessagePId, currentMessage.triaInitiatedMessagePId)}>
                          {/* //<a href={a.url.startsWith('http') ? a.url : `https://${a.url}`} rel="noreferrer" target="_blank"> */}
                          <Typography styles={{ textDecoration: 'underline', cursor: 'pointer' }} size={16}>
                            {a.displayName}
                          </Typography>
                          {/* //</a> */}
                        </Row>
                      </li>
                    ) : (
                      <></>
                    )
                  })}
                {currentMessage.conversations.map((m) => {
                  const result = m.patientAttachments
                    .filter((a) => a.attachmentType === 2 && a.fromTria)
                    .map((a) => {
                      return a.displayName ? (
                        <li>
                          <Row
                            onClick={() => handleOpenDoc(a.guid, currentMessage.patientInitiatedMessagePId, currentMessage.triaInitiatedMessagePId)}
                          >
                            {/* //<a href={a.url.startsWith('http') ? a.url : `https://${a.url}`} rel="noreferrer" target="_blank"> */}
                            <Typography styles={{ textDecoration: 'underline', cursor: 'pointer' }} size={16}>
                              {a.displayName}
                            </Typography>
                            {/* //</a> */}
                          </Row>
                        </li>
                      ) : (
                        <></>
                      )
                    })
                  return result
                })}
              </ul>
            </StyledLinkContainer>
          )}
        </>
      ) : (
        <></>
      )}
    </StyledCurrentMessageCardContainer>
  )
}

const StyledCurrentMessageCardContainer = styled.div`
  @media only screen and (min-width: 1000px) {
    flex-direction: column;
    margin-left: 51%;
    margin-top: -750px;
  }
`

const StyledConversationContainer = styled.div`
  scroll-behavior: smooth;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: 1px solid #bdbdbd;
  position: relative;
  margin-top: -10%;
  overflow-y: scroll;
  @media only screen and (min-width: 1000px) {
    max-height: 520px;
    width: 130%;
    margin-left: -30%;
  }

  @media only screen and (max-width: 1000px) {
    height: 570px;
    width: 100%;
    margin-top: 5%;
  }
`

const StyledLinkContainer = styled.div`
  scroll-behavior: smooth;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: 1px solid #bdbdbd;
  position: relative;
  margin-top: 3%;
  padding: 10px 20px;
  @media only screen and (min-width: 1000px) {
    max-height: 520px;
    width: 130%;
    margin-left: -30%;
  }

  @media only screen and (max-width: 1000px) {
    height: 570px;
    width: 100%;
    margin-top: 5%;
  }
`
const StyledInput = styled.textarea`
  border-radius: 3px;
  display: block;
  outline: none !important;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
`
const StyledFormInput = styled(StyledInput)`
  border: 2px solid #e0e0e0;
  min-height: 190px;
  margin-left: auto;
  margin-right: auto;
  width: 800px;
  padding: 20px;
`
